import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Form, Row, Col } from "reactstrap";
import "../../assets/scss/components/login-register/index.scss";
import Config from "../../utils/config";
import InputText from "../InputText";
import Icon from "react-icons-kit";
import { ic_remove_red_eye } from "react-icons-kit/md/ic_remove_red_eye";
import { eyeBlocked } from "react-icons-kit/icomoon/eyeBlocked";
import { ic_email } from "react-icons-kit/md/ic_email";
import { ic_lock } from "react-icons-kit/md/ic_lock";
import CustomBtn from "../CustomButton";
import Loader from "../Loader";

import get from "lodash/get";

const _ = { get };

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      ShowPassword: true,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  handleToggleIcon = () => {
    let state = { ...this.state };
    state.ShowPassword = !state.ShowPassword;
    this.setState({ ...state });
  };

  handleChange(e) {
    e.preventDefault();
    let state = { ...this.state };
    state[e.target.name] = e.target.value;
    this.setState({ ...state });
  }

  handleSubmit(e) {
    e.preventDefault();
    let state = this.state;
    let data = {
      username: state.username.trim(),
      password: state.password.trim(),
    };
    this.props.handleLoginUser(data);
  }

  render() {
    let { elements } = this.props;
    console.log("login", this.props.loginUserStatus);
    return (
      <React.Fragment>
        {this.props.loginUserStatus !== false ? <Loader /> : null}
        <Row className="no-gutters h-100">
          <Col
            sm="12"
            md="12"
            lg="12"
            xl="6"
            className="user-auth-wrapper h-100"
            style={{
              backgroundImage: `url(${Config.imageBaseUrl}/EU0001/node/assets/dashboard/riders-portal/login-banner.webp)`,
            }}
          ></Col>
          <Col sm="12" md="12" lg="12" xl="6" className="h-100 login-wrapper">
            <div className="light-overlay">
              <div className="user-auth-container">
                <div className="logo">
                  <img
                    src={`${Config.imageBaseUrl}/content/dam/re-platform-images/logo.svg`}
                    alt="logo"
                  />
                </div>

                <div className="app-login-register-container">
                  <Form onSubmit={this.handleSubmit} className="w-100">
                    <div className="p-2 p-lg-0">
                      <div className="position-relative">
                        <Icon
                          size={22}
                          className="inputIcon LeftIcon"
                          icon={ic_email}
                        />
                        <InputText
                          inputType={"text"}
                          inputName={"username"}
                          InputClass={"mt-3 mt-lg-5 mb-4 inputText"}
                          inputPlaceholder={_.get(
                            elements,
                            "loginElement.emailPlaceholder",
                            "Email / Mobile"
                          )}
                          customOnChange={(e) => this.handleChange(e)}
                          customRequired={true}
                        />
                      </div>
                      <div className="position-relative">
                        <Icon
                          size={22}
                          className="inputIcon LeftIcon"
                          icon={ic_lock}
                        />
                        <InputText
                          inputType={
                            this.state.ShowPassword ? "password" : "text"
                          }
                          inputName={"password"}
                          InputClass={"mt-2 mt-lg-5 mb-4 inputText"}
                          inputPlaceholder={_.get(
                            elements,
                            "loginElement.passwordPlaceholder",
                            "Password"
                          )}
                          customOnChange={(e) => this.handleChange(e)}
                          customRequired={true}
                          customIcon={ic_lock}
                          IconClass={"inputIcon LeftIcon"}
                          rightIcon={
                            this.state.ShowPassword
                              ? eyeBlocked
                              : ic_remove_red_eye
                          }
                          iconSize={22}
                        />
                        <Icon
                          size={18}
                          className="RightIcon inputIcon"
                          onClick={this.handleToggleIcon}
                          icon={
                            this.state.ShowPassword
                              ? eyeBlocked
                              : ic_remove_red_eye
                          }
                        />
                      </div>
                      <div className="bottom-sec">
                        <div className="d-flex align-items-center justify-content-center flex-column position-relative">
                          <CustomBtn
                            customType={"submit"}
                            name={_.get(
                              elements,
                              "loginElement.loginButtonElement",
                              "Login"
                            )}
                            customClass={"btn-outline-dark mb-4 btnthemeColor"}
                            iconSize={30}
                          />
                          <Link to="/auth/forget-password" className="link">
                            <span className="bg-white position-relative px-2">
                              {_.get(
                                elements,
                                "loginElement.forgotPasswordLinkElement",
                                " Forgot Password?"
                              )}
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}
Login.propTypes = {};
